import api from './api.js';

const TeamService = {
  /**
   * Drops a player from a team, making them a free agent.
   * @param {string} teamId - The ID of the team dropping the player.
   * @param {number} wyId - The WyScout ID of the player to drop.
   * @returns {Promise<Object>} - The API response.
   */
  async dropPlayer(teamId, wyId, leagueId) {
    if (!teamId || !wyId) {
      throw new Error("Team ID and Player ID are required to drop a player.");
    }
    if (!leagueId) {
      throw new Error("League ID is required to drop a player.");
    }
    return api.delete(`/teams/${teamId}/players/${wyId}/drop`, { params: { leagueId } });
  }
};

export default TeamService;
